import { createFileRoute } from '@tanstack/react-router'
import { EventsTimeline } from '@/components/settings/events-timeline'
import { PageHeader } from '@/components/shared/page-header'

export const Route = createFileRoute('/_app/settings/history')({
  component: HistoryPage,
})

function HistoryPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        size="sm"
        title="Histórico"
        description="Acompanhe todos os eventos que entraram e saíram do Rafobase."
      />

      <EventsTimeline />
    </div>
  )
}
